import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import DataGridCell from 'components/enhanced/data-grid/components/cell/DataGridCell';
import { dateFilterOperators } from 'components/enhanced/data-grid/utils/filters';
import TenantPage from 'layouts/TenantPage';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ISapSyncLog } from 'features/settings/history/types';
import { sapSyncLogService } from '../api/sap-sync-log.service';
import { dateTimeCell } from 'components/cells/date-time-cell';
import { baseCell } from 'components/cells/BaseCell';

export const SapSyncLogPage = () => {
  const translationPrefix = 'pages.sap_sync_logging';
  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const columns: GridColDef[] = [
    {
      field: 'log_type',
      headerName: t(`global.type`),
      flex: 1,
      renderCell: baseCell
    },
    {
      field: 'timestamp',
      headerName: t(`${translationPrefix}.timestamp`),
      flex: 1,
      filterOperators: dateFilterOperators,
      renderCell: dateTimeCell
    },
    {
      field: 'operation',
      headerName: t(`${translationPrefix}.operation`),
      flex: 1,
      renderCell: ({
        row: {
          structured_log_message: { operation }
        }
      }: {
        row: ISapSyncLog;
      }) => <div>{operation}</div>
    },
    {
      field: 'message',
      headerName: t(`${translationPrefix}.message`),
      flex: 1,
      renderCell: ({
        row: {
          structured_log_message: { message }
        }
      }: {
        row: ISapSyncLog;
      }) => <DataGridCell content={message} />
    },
    {
      field: 'entity',
      headerName: t(`${translationPrefix}.entity`),
      flex: 1,
      renderCell: ({
        row: {
          structured_log_message: { entity }
        }
      }: {
        row: ISapSyncLog;
      }) => <div>{entity}</div>
    },
    {
      field: 'sap_id',
      headerName: t(`${translationPrefix}.sap_id`),
      flex: 1,
      renderCell: ({
        row: {
          structured_log_message: { sap_id }
        }
      }: {
        row: ISapSyncLog;
      }) => <div>{sap_id}</div>
    }
  ];

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <EnhancedDataGrid refresh={datagridRefresh} service={sapSyncLogService} columns={columns} />
    </TenantPage>
  );
};

export default SapSyncLogPage;
